// eslint-disable-next-line no-restricted-imports
import { Link, NavLink } from 'react-router-dom';

import { AppPath } from 'utils/url/appPaths';
import { AppUrlOptions } from 'utils/url/createAppUrl';

import { LinkProps, NavLinkProps } from './appLink.types';
import { createTo } from './utils/createTo';

/**
 * A component that wraps the native react-router-dom <Link> component with a
 * strongly typed interface.
 */
export const AppLink = <TAppPath extends AppPath>(
  options: AppUrlOptions<TAppPath> & LinkProps,
): JSX.Element => {
  return (
    <Link {...options} to={createTo(options)}>
      {options.children}
    </Link>
  );
};

/**
 * A component that wraps the native react-router-dom <NavLink> component with a
 * strongly typed interface.
 */
export const AppNavLink = <TAppPath extends AppPath>(
  options: AppUrlOptions<TAppPath> & NavLinkProps,
): JSX.Element => {
  return (
    <NavLink {...options} to={createTo(options)}>
      {options.children}
    </NavLink>
  );
};
